import { Dispatch, SetStateAction, useEffect, useState } from 'react';

const APP_TITLE = 'Vyaguta';

const useTitle = (initialTitle: string | null = null): Dispatch<SetStateAction<string | null>> => {
  const [title, setTitle] = useState<string | null>(initialTitle);

  useEffect(() => {
    if (!title) {
      document.title = APP_TITLE;
      return;
    }

    document.title = `${title} | ${APP_TITLE}`;
  }, [title]);

  return setTitle;
};

export default useTitle;
